module.exports = __webpack_public_path__ + "img/traffic.f661c442.png";